var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"default"},[_c('c-header'),_vm._v(" "),_c('transition',{attrs:{"name":"layout","mode":"out-in"}},[_c('nuxt')],1),_vm._v(" "),_c('c-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }